module.exports = __webpack_public_path__ + "static/media/Passsme.lk.fa0fb6a7.png";